// extracted by mini-css-extract-plugin
export default {"info-tags":"OPInfoTags_info-tags__Y4yW-","info-stat":"OPInfoTags_info-stat__Z8QIj","tag":"OPInfoTags_tag__HhXZb"};